
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Fitness-Weights--Streamline-Streamline--3.0.svg","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"24","width":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('desc',[_v('Fitness Weights Streamline Icon: https://streamlinehq.com')]),_c('defs'),_c('title',[_v('fitness-weights')]),_c('path',{attrs:{"d":"m8.25 11.5 7.5 0","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M6.75 17.5a1.5 1.5 0 0 1 -1.5 -1.5V7a1.5 1.5 0 0 1 3 0v9a1.5 1.5 0 0 1 -1.5 1.5Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m2.25 11.5 -1.5 0","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M3.75 8.5a1.5 1.5 0 0 0 -1.5 1.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -1.5 -1.5Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M17.25 17.5a1.5 1.5 0 0 0 1.5 -1.5V7a1.5 1.5 0 0 0 -3 0v9a1.5 1.5 0 0 0 1.5 1.5Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"m21.75 11.5 1.5 0","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M20.25 8.5a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1 -3 0v-3a1.5 1.5 0 0 1 1.5 -1.5Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    